var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"view-header"},[(_vm.hasTitleSlot)?_c('div',{staticClass:"container"},[_c('h1',{staticClass:"view-header__title"},[_vm._t("title")],2),_c('div',{staticClass:"view-header__intro"},[_vm._t("intro")],2)]):_c('div',[_vm._t("content")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }